export class AuthError extends Error {}
export class AuthenticateError extends AuthError {
  constructor(message, upstreamErrorMessage) {
    super(message);
    this.type = 'AuthenticateError';
    this.name = 'AuthenticateError';
    this.upstreamErrorMessage = upstreamErrorMessage;
  }
  toAuthError() {
    return {
      type: this.type,
      message: this.message,
      upstreamErrorMessage: this.upstreamErrorMessage
    };
  }
}